import React, { useState, MouseEvent, useRef, useEffect } from "react";
import classnames from "classnames/bind";
import style from "./index.module.scss";
import {
  IState,
  ITWorkshop,
  LocationType,
  Replacement,
} from "../../../../interface";
import analyseData from "../../../../utils/analyseData";
import _ from "lodash";
import moment from "moment";
import { checkHttpAddress } from "../../../../utils/validate";
import localesReplacement from "../../../../utils/localesReplacement";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import actions from "../../../../redux/actions";
import ClickOut from "react-click-out";
import {
  ANALYTICS_EVENT,
  ANALYTICS_PAGE_TYPE,
  ANALYTICS_SERVICE_TYPE,
  CountriesWithCustomizedWTB,
} from "../../../../constants";
import { getLocationImage } from "../../../../utils";
import { useAnalytics } from "../../../../hooks/use-analytics";
import { StringOrCallback } from "victory";
import { te } from "date-fns/locale";


const cx = classnames.bind(style);
/* eslint-disable */
interface IProps {
  dataList: ITWorkshop;
  selectedLocation: ITWorkshop | null;
  replacements: Replacement;
  isMiles: boolean;
  onContactClick: (value: ITWorkshop) => void;
  onBookClick: (value: ITWorkshop) => void;
  setSelectedLocation: (value: ITWorkshop | null) => void;
  setAccord: (value: boolean) => void;
}

interface IAddressData {
  line1: string | null;
  line2: string | null;
  townOrCity: string | null;
  postCode: string | null;
  telephone:string|null
  
}

//Workshop detail component
function Workshop(props: IProps) {
  const {
    dataList,
    selectedLocation,
    replacements,
    setSelectedLocation,
    setAccord,
    isMiles,
  } = props;
  const window: any = globalThis;
  const sendAnalytics = useAnalytics();
  const setActiveLocation = (evt: MouseEvent) => {
    sendAnalytics({
      event: ANALYTICS_EVENT.WHERE_TO_BUY_CARD_CLICK,
      page: ANALYTICS_PAGE_TYPE.WHERE_TO_BUY,
      serviceType: dataList.locationTypes[0].name.toLocaleLowerCase(),
      country: localStorage.getItem("countryCode") || "",
      serviceOutlet: dataList.name.toLocaleLowerCase(),
    });
    setSelectedLocation(dataList);
    evt.stopPropagation();
  };
  const urlDataLayer = (evt: MouseEvent) => {
    sendAnalytics({
      event: ANALYTICS_EVENT.WHERE_TO_BUY_URL_CLICK,
      page: ANALYTICS_PAGE_TYPE.WHERE_TO_BUY,
      serviceType: dataList.locationTypes[0].name.toLowerCase(),
      country: localStorage.getItem("countryCode") || "",
      serviceOutlet: dataList.name.toLocaleLowerCase(),
    });
    evt.stopPropagation();
  };
  const bmgDataLayer = () => {
    sendAnalytics({
      event: ANALYTICS_EVENT.WHERE_TO_BUY_URL_CLICK,
      page: ANALYTICS_PAGE_TYPE.WHERE_TO_BUY,
      serviceType: ANALYTICS_SERVICE_TYPE.BOOK_MY_GARAGE,
      country: localStorage.getItem("countryCode") || "",
      serviceOutlet: dataList.name.toLocaleLowerCase(),
    });
  };
  const clickout = (evt: globalThis.MouseEvent) => {
    const map = document.getElementById("google-map");
    if (!map?.contains(evt.target as Node)) {
      setSelectedLocation(null);
    }
  };
  const checkAddressIsNull = (address: IAddressData) => {
    return (
      address.line1 === null ||
      (address.line1.trim() === "" && address.line2 === null) ||
      (address.line2?.trim() === "" && address.townOrCity === null) ||
      (address.townOrCity?.trim() === "" && address.postCode === null) ||
      address.postCode?.trim() === "" &&
      address.telephone?.trim() === "" && address.telephone === null
      );
  };
  const handleBookNow = (url: string) => {
    bmgDataLayer();
    // TODO : possible place to trigger validation dialog box
    window.open(checkHttpAddress(url) ? url : "https://" + url);
  };

  const localizeLocationType = (locationTypes: LocationType[]) => {
    return locationTypes.map((item) =>
      localesReplacement(replacements, item.name)
    );
  };

  const openLink = () => {
    const link = checkHttpAddress(dataList["website"])
      ? dataList["website"]
      : "https://" + dataList["website"];
    const element = document.querySelector(
      "#external-link-popover"
    ) as HTMLElement;
    if (element) {
      element.dataset.link = link; 
      (element as any).showPopover();
    } 
  };

  const [openHoursVisible, setOpenHoursVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {}, []);

  return (
    <ClickOut className={cx("click-out")} onClickOut={(e) => clickout(e)}>
      <div
        className={cx("workshop", "workshop-wrapper")}
        onClick={(evt) => {
          if (checkAddressIsNull(dataList["address"])) {
            evt.stopPropagation();
            openLink();
          } else {
            setActiveLocation(evt);
            setAccord(true);
          }
        }}
      >
        <div className={cx("thumb")}>
          {/* banner */}
          <img src={getLocationImage(dataList)} />
          {dataList?.castrolCertified && (
            <span className={cx("recommendation")}>
              {localesReplacement(replacements, "Castrol Certified")}
            </span>
          )}
        </div>
        {/* workshop information */}
        <div className={cx("content")}>
          <div className={cx("block")}>
            {!checkAddressIsNull(dataList["address"]) ? (
              <p className={cx("distance")}>
                {_.round(+dataList["distanceInMiles"], 1)}{" "}
                {isMiles ? "mil" : "km"}
              </p>
            ) : (<p className={cx('distance')}></p>)}
            <div className={cx("meta")}>
              <p className= {cx('')}>
                {localesReplacement(
                  replacements,
                  _.join(localizeLocationType(dataList["locationTypes"]))
                )}
              </p>
              {dataList["website"] && (
                <a
                  onClick={urlDataLayer}
                  className={cx("share")}
                  target="_blank"
                  rel="noreferrer"
                  href={
                    checkHttpAddress(dataList["website"] ?? "")
                      ? dataList["website"]
                      : "https://" + dataList["website"]
                  }
                ></a>
              )}
            </div>
          </div>

          <div className={cx("heading")}>
            <h4>{dataList["name"]}</h4>
          </div>
          <ul>
            {!checkAddressIsNull(dataList["address"]) && (
              <li className={cx("address")}>
                <span className="overflowText">
                  {dataList["address"]["line1"]}
                  {dataList["address"]["townOrCity"] !== null && ","}
                  {dataList["address"]["townOrCity"] === null &&
                    dataList["address"]["postCode"] !== null &&
                    ","}{" "}
                  {dataList["address"]["townOrCity"]}
                  {dataList["address"]["postCode"] !== null && ","}
                  {dataList["address"]["county"]}
                  {dataList["address"]["county"] !== null && ","}
                  {dataList["address"]["postCode"]}
                </span>
              </li>
            )}

            {dataList["telephone"] && (
              <li className={cx("phone")}>
                <a
                  href={`tel:${dataList["telephone"]}`}
                  className="overflowText"
                  onClick={(evt) => evt.stopPropagation()}
                >
                  {dataList["telephone"]}
                </a>
              </li>
            )}
            {dataList["email"] && (
              <li className={cx("email")}>
                <span className="overflowText">{dataList["email"]}</span>
              </li>
            )}
            {!_.isEmpty(
              _.flatMap(dataList["openingHours"], (item) => {
                return _.compact(_.values(_.pick(item, "open", "close")));
              })
            ) && (
              <li
                className={cx("time", { on: openHoursVisible })}
                onClick={(evt) => evt.stopPropagation()}
              >
                <span
                  className={cx("icon-time")}
                  data-title="opening_hours"
                  onClick={() => {
                    setOpenHoursVisible(true);
                  }}
                  ref={ref}
                >
                  {localesReplacement(replacements, "Opening Hours")}
                </span>
                <div
                  className={cx("mask", { on: openHoursVisible })}
                  onClick={() => {
                    setOpenHoursVisible(false);
                  }}
                ></div>
                <div
                  className={cx("list", {
                    on: openHoursVisible,
                    left:
                      _.toNumber(ref.current?.getBoundingClientRect().left) +
                        _.toNumber(ref.current?.getBoundingClientRect().width) +
                        300 >=
                      document.body.clientWidth,
                  })}
                >
                  <div className={cx("caption")}>
                    {localesReplacement(replacements, "Opening Hours")}
                  </div>
                  <div className={cx("hours-list")}>
                    {_.map(
                      _.sortBy(dataList["openingHours"], "isoWeekday"),
                      (item, index) =>
                        !!item["open"] && !!item["close"] ? (
                          <div key={index} className={cx("item")}>
                            <span>
                              {localesReplacement(
                                replacements,
                                moment.weekdaysShort(item["isoWeekday"])
                              )}
                              :
                            </span>
                            {localesReplacement(replacements, "Opens from")}{" "}
                            {item["open"]
                              ? analyseData.hourFormat(item["open"])
                              : ""}{" "}
                            -{" "}
                            {item["close"]
                              ? analyseData.hourFormat(item["close"])
                              : ""}
                          </div>
                        ) : null
                    )}
                  </div>
                </div>
              </li>
            )}
            {dataList["website"] && (
              <li className={cx("website")}>
                <a
                  onClick={urlDataLayer}
                  className="overflowText"
                  target="_blank"
                  rel="noreferrer"
                  href={
                    checkHttpAddress(dataList["website"])
                      ? dataList["website"]
                      : "https://" + dataList["website"]
                  }
                >
                  {dataList["website"]}
                </a>
              </li>
            )}
            {dataList["website"] && (
              <li className={cx("website")}>
                <button
                  data-popovertarget="external-link-popover"
                  data-popoveraction="show"
                  data-target="_blank"
                  rel="noreferrer"
                  onClick={openLink}
                >
                  {dataList["website"]}
                </button>
              </li>
            )}
          </ul>
          {/* 3746334 */}
          {!CountriesWithCustomizedWTB.includes(localStorage.countryCode) && (
            <dl>
              <dt>{localesReplacement(replacements, "Location type")}: </dt>
              <dd className="overflowText">
                {localesReplacement(
                  replacements,
                  _.join(localizeLocationType(dataList["locationTypes"]))
                )}
              </dd>
            </dl>
          )}
          {/* 6333728: Book My Garage */}
          {dataList["bmgWebsite"] && (
            <div className={cx("button-container")}>
              <button
                className={cx("book-now-button")}
                onClick={() => handleBookNow(dataList["bmgWebsite"])}
              >
                {localesReplacement(replacements, "Book Now")}
              </button>
            </div>
          )}
        </div>
      </div>
    </ClickOut>
  );
}

const mapStateToProps = (state: IState) => ({
  selectedLocation: state.selectedLocation,
  replacements: state.replacements,
  country: state.country,
  isMiles: state.isMiles,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectedLocation: (value: ITWorkshop | null) =>
    dispatch(actions.setSelectedLocation(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Workshop);
